import { ConfettiDark, ConfettiLight } from "@assets";
import { Card, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { EventType } from "@models/event";
import Image from "next/image";
import { useMemo } from "react";
import CheckoutSuccessButtons from "../CheckoutSuccessButtons/CheckoutSuccessButtons";

const _t = (key?: string) => key || "";

const CheckoutSuccessHeadings = ({
  heading = "Order Confirmed",
  title = "We are processing your order.",
  subtitle = "Once your payment is confirmed (if any), we will send you a confirmation email with your order details.",
  remark = "* Please note that processing crypto payments may take up to 30 minutes. We kindly ask for your patience during this time.",
  eventType = EventType.TICKET,
}: {
  heading?: string;
  title?: string;
  subtitle?: string;
  remark?: string;
  eventType?: EventType;
}) => {
  const bg = useColorModeValue("", "gradientDark");
  const buttonTexts = useMemo(() => {
    switch (eventType) {
      case EventType.BENEFIT:
        return {
          appText: "See Benefits",
          eventText: "",
        };
      case EventType.MEMBERSHIP:
        return {
          appText: "See my NFT",
          eventText: "See Benefits",
        };
      case EventType.TICKET:
      default:
        return {
          appText: "See Ticket & Benefits",
          eventText: "Back to Event",
        };
    }
  }, [eventType]);
  return (
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="stretch"
      width="100%"
      gap={4}
    >
      <Flex
        direction="row"
        justifyContent="start"
        alignItems="center"
        gridGap={2}
      >
        <Image
          src={useColorModeValue(ConfettiLight, ConfettiDark)}
          alt="confetti"
          width={50}
          height={50}
        />
        <Text
          fontWeight="600"
          className="text-2xl font-medium text-primary-500 dark:text-white"
        >
          {_t(heading)}
        </Text>
      </Flex>
      <Card
        direction="column"
        overflow="hidden"
        className="items-start"
        borderRadius="xl"
        width={"full"}
        bg={bg}
        px={8}
      >
        <Text
          className="text-xl sm:text-2xl dark:text-white mt-4"
          fontWeight="600"
          align="center"
        >
          {_t(title)}
        </Text>
        <Text
          className="text-sm sm:text-lg"
          align="center"
          color={useColorModeValue("", "neutral.100")}
          marginTop={2}
        >
          {_t(subtitle)}
        </Text>
        <Text
          className="text-sm sm:text-sm"
          align="center"
          color="neutral.500"
          marginTop={2}
        >
          {_t(remark)}
        </Text>
        <CheckoutSuccessButtons
          redirectToAppText={buttonTexts.appText}
          redirectToEventText={buttonTexts.eventText}
          type={eventType}
        />
      </Card>
    </Flex>
  );
};

export default CheckoutSuccessHeadings;
